function setupToggleOnTrigger() {
  // Get all elements that act as triggers
  const triggers = document.querySelectorAll<HTMLElement>('[data-wf-toggle-id]');
  function clearFieldValues(targetElement: Element|HTMLElement): void {
    if (targetElement.tagName === "SELECT") {
      const selectElement = targetElement as HTMLSelectElement;
      selectElement.selectedIndex = -1;
    } else if (targetElement.tagName === "INPUT") {
      const inputElement = targetElement as HTMLInputElement;
      if (inputElement.matches('input[type="checkbox"], input[type="radio"]')) {
        inputElement.checked = false;
      } else {
        inputElement.value = '';
      }
    } else if (targetElement.tagName === "TEXTAREA") {
      // It is unclear if for textareas we want to clear field values. Uncomment this if we want that behavior.
      // Note textarea usage in the ID card form
      //const textareaElement = targetElement as HTMLTextAreaElement;
      //textareaElement.value = '';
    } 
  }

  // take in a toggleId and toggleTrigger tag of the initiating radio / checkbox / whatever, and clear / reupdate any items that match those values.
  const toggleVisibility = (toggleId, toggleTrigger) => {

    if (!toggleId) return;

    // Use CSS.escape when interpolating toggleId into a selector to avoid invalid selectors
    const escapedToggleId = typeof CSS !== 'undefined' && typeof (CSS as any).escape === 'function' ? (CSS as any).escape(toggleId) : toggleId;

    // Collect all targets for this toggleId and decide whether to show or hide them, then apply changes in batch.
    const allTargets = Array.from(document.querySelectorAll(`[data-wf-toggle-for="${escapedToggleId}"]`)) as HTMLElement[];
    const toShow: HTMLElement[] = [];
    const toHide: HTMLElement[] = [];

    allTargets.forEach(target => {
      const hasTargetAttr = target.hasAttribute('data-wf-toggle-target');
      const multipleTargets = target.hasAttribute('data-wf-toggle-multiple');
      const targetAttr = target.getAttribute('data-wf-toggle-target');
      const isEventTrigger = target.hasAttribute('data-wf-toggle-event');

      if (hasTargetAttr) {
        // If the element has a data-wf-toggle-target, show it only when it matches the toggleTrigger (truthy)
        let isMatch = false;
        if (toggleTrigger && !multipleTargets && targetAttr === toggleTrigger) {
          isMatch = true;
          toShow.push(target);
        }
        if (toggleTrigger && multipleTargets) {
            // Treat the target attribute as a semicolon-separated list and match any item
            const items = (targetAttr || '').split(';').map(s => s.trim()).filter(s => s.length > 0);
            if (items.indexOf(toggleTrigger) !== -1) {
              isMatch = true;
              toShow.push(target);
            }
        }
        if (!isMatch) {
          toHide.push(target);
        }
      } else {
        // Elements without a specific target: only consider those that are not themselves event triggers
        if (!isEventTrigger) {
          if (toggleTrigger) {
            toShow.push(target);
          } else {
            toHide.push(target);
          }
        }
        // If it's an event trigger element with no target attr, leave it alone (do not change)
      }
    });

    // Apply hides
    toHide.forEach(target => {
      const targetElement = target as HTMLElement;
      targetElement.style.display = 'none';
      targetElement.querySelectorAll('input, select, textarea').forEach(x => {
        x.setAttribute('disabled', 'disabled');
        if (x.getAttribute("type") !== 'submit') {
          clearFieldValues(x);
        }
      });
    });

    // Apply shows
    toShow.forEach(target => {
      const displayValue = target.getAttribute('data-wf-toggle-display');
      const targetElement = target as HTMLElement;
      targetElement.style.display = (displayValue ? displayValue : 'block');
      targetElement.querySelectorAll('input, select, textarea').forEach(x => x.removeAttribute('disabled'));
    });
  }

  const elementToggleVisibility = (element) => {
    if (element.matches('[data-wf-toggle-id]')) {
      const toggleId = element.getAttribute('data-wf-toggle-id');
      let toggleTrigger = "";

      if (element.tagName === 'SELECT') {
        const toggleSelect = (element as HTMLSelectElement);
        const toggleSelectedOption = toggleSelect.options[toggleSelect.selectedIndex];
        if (!toggleSelectedOption) {
          toggleTrigger = null;
        } else if (toggleSelectedOption.matches('[data-wf-toggle-trigger]')) {
          toggleTrigger = toggleSelectedOption.getAttribute('data-wf-toggle-trigger');
        }
      }
      else if (element.matches('[data-wf-toggle-trigger]')) {
        if (element.matches('input[type="checkbox"], input[type="radio"]')) {
          if (element.checked) {
            toggleTrigger = element.getAttribute('data-wf-toggle-trigger');
          } else {
            return;
            //Note: This means a checkbox/radio uncheck won't hide anything, it just won't toggle anything on.
            //toggleTrigger = null; //Do this instead if checkboxes/radios should hide elements on uncheck.
            //So far, this situation hasn't come up, all current toggles are on lists.
          }
        }
        else {
          toggleTrigger = element.getAttribute('data-wf-toggle-trigger');
        }
      }
      else {
        return;
      }

      toggleVisibility(toggleId, toggleTrigger);
    }
  };

  const eventToggleVisibility = (event) => {
    elementToggleVisibility(event.target);
  };

  triggers.forEach(trigger => {
    const toggleEvent = trigger.getAttribute('data-wf-toggle-event');

    if (toggleEvent === 'change') {
      trigger.addEventListener('change', eventToggleVisibility);
    } else if (toggleEvent === 'click') {
      trigger.addEventListener('click', eventToggleVisibility);
    }

    //Do an initial check to see if the trigger is checked, and if so, toggle visibility
    elementToggleVisibility(trigger);
  });
}

// Initialize toggle functionality
setupToggleOnTrigger();

